const API_BASE_PATH = '/roles'

const ROLES = {
  LIST: `${API_BASE_PATH}`
}

export default ROLES
